export const TablePaginationKeys = {
    AssetRowsPerPage: 'asset_rows_per_page',
    CustomerRowsPerPage: 'customer_rows_per_page',
    DepartmentRowsPerPage: 'department_rows_per_page',
    EmployeeRowsPerPage: 'employee_rows_per_page',
    InvoiceRowsPerPage: 'invoice_rows_per_page',
    InventoryOrderTableRowsPerPage: 'inventory_order_table_rows_per_page',
    InventoryTableRowsPerPage: 'inventory_table_rows_per_page',
    LocationRowsPerPage: 'location_rows_per_page',
    ProductRowsPerPage: 'product_rows_per_page',
    RoleRowsPerPage: 'role_rows_per_page',
    SupplierRowsPerPage: 'supplier_rows_per_page',
    UnitOfMeasureRowsPerPage: 'unit_of_measure_rows_per_page'
};
